// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------
| Variables
|----------------------------------------------------------------------------*/

:root {
  --jp-private-filebrowser-button-height: 28px;
  --jp-private-filebrowser-button-width: 48px;
}

.jp-FileBrowser .jp-SidePanel-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.jp-FileBrowser-toolbar.jp-Toolbar {
  border-bottom: none;
  height: auto;
  margin: 8px 12px 0;
  box-shadow: none;
  padding: 0;
}

.jp-FileBrowser-toolbar.jp-Toolbar::part(positioning-region) {
  row-gap: 12px;
}

.jp-FileBrowser-filterToolbar {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}

.jp-FileBrowser-filterToolbar.jp-Toolbar {
  border-bottom: none;
  height: auto;
  margin: 0 12px 6px;
  box-shadow: none;
  padding: 0;
}

.jp-FileBrowser-Panel {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.jp-BreadCrumbs {
  flex: 0 0 auto;
  margin: 8px 12px;
}

.jp-BreadCrumbs-item {
  margin: 0 2px;
  padding: 0 2px;
  border-radius: var(--jp-border-radius);
  cursor: pointer;
}

.jp-BreadCrumbs-item:hover {
  background-color: var(--jp-layout-color2);
}

.jp-BreadCrumbs-item:first-child {
  margin-left: 0;
}

.jp-BreadCrumbs-item.jp-mod-dropTarget {
  background-color: var(--jp-brand-color2);
  opacity: 0.7;
}

/*-----------------------------------------------------------------------------
| Buttons
|----------------------------------------------------------------------------*/

.jp-FileBrowser-toolbar > .jp-Toolbar-item,
.jp-FileBrowser-filterToolbar > .jp-Toolbar-item {
  flex: 0 0 auto;
  padding-left: 0;
  align-items: center;
  height: unset;
}

.jp-FileBrowser-toolbar > .jp-Toolbar-item .jp-ToolbarButtonComponent {
  width: 28px;
}

/*-----------------------------------------------------------------------------
| Other styles
|----------------------------------------------------------------------------*/

.jp-FileDialog.jp-mod-conflict input {
  color: var(--jp-error-color1);
}

.jp-FileDialog .jp-new-name-title {
  margin-top: 12px;
}

.jp-FileBrowser .lm-AccordionPanel > h3:first-child {
  display: none;
}

.jp-FileBrowser-filterToolbar > .jp-FileBrowser-filterBox {
  width: 100%;
}

.jp-FileBrowser-filterBox > .jp-FilterBox {
  width: 100%;
}

.jp-Open-Dialog > .jp-FileBrowser {
  min-height: 200px;
}

.jp-Open-Dialog-label {
  overflow: visible;
}

/*-----------------------------------------------------------------------------
| DirListing
|----------------------------------------------------------------------------*/

.jp-DirListing {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  outline: 0;
  overflow: hidden;

  --jp-dirlisting-padding-width: 12px;
}

.jp-DirListing-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  border-top: var(--jp-border-width) solid var(--jp-border-color2);
  border-bottom: var(--jp-border-width) solid var(--jp-border-color1);
  box-shadow: var(--jp-toolbar-box-shadow);
  z-index: 2;
  user-select: none;
}

.jp-DirListing-headerItem {
  padding: 4px 12px 2px;
  font-weight: 500;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  display: flex;
}

.jp-DirListing-headerItemText {
  flex-grow: 1;
  text-overflow: ellipsis;
  overflow: hidden;
}

.jp-DirListing-headerItem:hover {
  background: var(--jp-layout-color2);
}

.jp-DirListing-headerItem.jp-id-name:not([style*='width']) {
  /* default width before user resizes this column */
  flex: 1 1 126px;
}

.jp-DirListing-headerItem.jp-id-modified:not([style*='width']) {
  /* default width before user resizes this column */
  flex: 1 0 70px;
}

.jp-DirListing-headerItem.jp-id-filesize:not([style*='width']) {
  /* default width before user resizes this column */
  flex: 0 0 75px;
}

.jp-DirListing-headerItem.jp-id-modified,
.jp-DirListing-headerItem.jp-id-filesize {
  text-align: right;
  /* stylelint-disable */
  container-type: inline-size;
  /* stylelint-enable */
}

/**
 * Use container queries (not yet supported by our version of stylelint)
 * to display either a small or large header for the last-modified column.
 */
/* stylelint-disable */
@container (max-width: 300px) {
  /* stylelint-enable */
  .jp-DirListing-headerItem.jp-id-modified
    > .jp-DirListing-headerItemText-small,
  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-small {
    display: inline;
  }

  .jp-DirListing-headerItem.jp-id-modified
    > .jp-DirListing-headerItemText-large,
  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-large {
    display: none;
  }
}

/* stylelint-disable */
@container (min-width: 300px) {
  /* stylelint-enable */
  .jp-DirListing-headerItem.jp-id-modified
    > .jp-DirListing-headerItemText-small {
    display: none;
  }

  .jp-DirListing-headerItem.jp-id-modified
    > .jp-DirListing-headerItemText-large {
    display: inline;
  }
}

/* stylelint-disable */
@container (max-width: 100px) {
  /* stylelint-enable */
  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-small {
    display: inline;
  }

  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-large {
    display: none;
  }
}

/* stylelint-disable */
@container (min-width: 100px) {
  /* stylelint-enable */
  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-small {
    display: none;
  }

  .jp-DirListing-headerItem.jp-id-filesize
    > .jp-DirListing-headerItemText-large {
    display: inline;
  }
}

.jp-DirListing-headerItem.jp-mod-selected {
  font-weight: 600;
}

/* increase specificity to override bundled default */
.jp-DirListing-content {
  flex: 1 1 auto;
  margin: 0;
  padding: 0;
  list-style-type: none;
  overflow: auto;
  background-color: var(--jp-layout-color1);
  overflow-x: hidden;
}

.jp-DirListing-content mark {
  color: var(--jp-ui-font-color0);
  background-color: transparent;
  font-weight: bold;
}

.jp-DirListing-content .jp-DirListing-item.jp-mod-selected mark {
  color: var(--jp-ui-inverse-font-color0);
}

/* Style the directory listing content when a user drops a file to upload */
.jp-DirListing.jp-mod-native-drop .jp-DirListing-content {
  outline: 5px dashed rgba(128, 128, 128, 0.5);
  outline-offset: -10px;
  cursor: copy;
}

.jp-DirListing-item {
  align-items: center;
  padding: 4px var(--jp-dirlisting-padding-width);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: inline-grid;
  grid-auto-columns: max-content;
  width: 100%;
  box-sizing: border-box;
  grid-auto-flow: column;
}

.jp-DirListing-checkboxWrapper {
  /* Increases hit area of checkbox. */
  padding: 4px;
}

.jp-DirListing-content .jp-DirListing-checkboxWrapper {
  position: relative;
  left: -4px;
  margin: -4px 0 -4px -8px;
}

.jp-DirListing-checkboxWrapper.jp-mod-visible {
  visibility: visible;
}

/* For devices that support hovering, hide checkboxes until hovered, selected...
*/
@media (hover: hover) {
  .jp-DirListing-checkboxWrapper {
    visibility: hidden;
  }

  .jp-DirListing-item:hover .jp-DirListing-checkboxWrapper,
  .jp-DirListing-item.jp-mod-selected .jp-DirListing-checkboxWrapper {
    visibility: visible;
  }
}

.jp-DirListing-resizeHandle {
  min-width: var(--jp-border-width);
  background: var(--jp-border-color2);
  height: calc(100% - 4px);

  /* border increases the area where handle can be grabbed */
  border: 2px solid var(--jp-layout-color1);
}

.jp-DirListing-resizeHandle.jp-mod-active {
  background: var(--jp-brand-color1);
  border-color: var(--jp-brand-color1);
}

.jp-DirListing-resizeHandle.jp-mod-active:hover {
  border-color: var(--jp-brand-color1);
}

.jp-DirListing-resizeHandle:hover {
  cursor: col-resize;
  border-color: var(--jp-border-color2);
}

.jp-DirListing-itemName {
  display: flex;
}

.jp-DirListing-item[data-is-dot] {
  opacity: 75%;
}

.jp-DirListing-item.jp-mod-selected {
  color: var(--jp-ui-inverse-font-color1);
  background: var(--jp-brand-color1);
}

.jp-DirListing-item.jp-mod-dropTarget {
  background: var(--jp-brand-color3);
}

.jp-DirListing-item:hover:not(.jp-mod-selected) {
  background: var(--jp-layout-color2);
}

.jp-DirListing-itemIcon {
  flex: 0 0 20px;
  margin-right: 4px;
}

.jp-DirListing-itemText,
.jp-DirListing-itemModified,
.jp-DirListing-itemFileSize {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jp-DirListing-itemName:not([style*='width']) > .jp-DirListing-itemText {
  flex: 1 1 106px;
}

.jp-DirListing-item:has(.jp-DirListing-itemText:focus-visible) {
  /* Targeting \`.jp-DirListing-itemText\` specifically to avoid an extra outline
  when it gets replaced with \`jp-DirListing-editor\` when editing the file name */
  outline-width: 2px;
  outline-color: var(--jp-inverse-layout-color1);
  outline-style: solid;
  outline-offset: -4px;
}

.jp-DirListing-item.jp-mod-selected:focus-within {
  outline-color: var(--jp-layout-color1);
}

.jp-DirListing-item > .jp-DirListing-itemName > .jp-DirListing-itemText:focus {
  outline: 0;
}

.jp-DirListing-itemModified {
  text-align: right;
}

.jp-DirListing-itemFileSize {
  text-align: right;
}

.jp-DirListing-editor {
  flex: 1 0 64px;
  outline: none;
  border: none;
  color: var(--jp-ui-font-color1);
  background-color: var(--jp-layout-color1);
}

.jp-DirListing-item.jp-mod-running .jp-DirListing-itemIcon::before {
  color: var(--jp-success-color1);
  content: '\\25CF';
  font-size: 8px;
  position: absolute;
  left: -8px;
}

.jp-DirListing-item.jp-mod-running.jp-mod-selected
  .jp-DirListing-itemIcon::before {
  color: var(--jp-ui-inverse-font-color1);
}

.jp-DirListing-item.lm-mod-drag-image,
.jp-DirListing-item.jp-mod-selected.lm-mod-drag-image {
  font-size: var(--jp-ui-font-size1);
  padding-left: 4px;
  margin-left: 4px;
  width: 160px;
  background-color: var(--jp-ui-inverse-font-color2);
  box-shadow: var(--jp-elevation-z2);
  border-radius: 0;
  color: var(--jp-ui-font-color1);
  transform: translateX(-40%) translateY(-58%);
}

.jp-Document {
  min-width: 120px;
  min-height: 120px;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/filebrowser/style/base.css"],"names":[],"mappings":"AAAA;;;8EAG8E;;AAE9E;;8EAE8E;;AAE9E;EACE,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;;8EAE8E;;AAE9E;;EAEE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;8EAE8E;;AAE9E;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;8EAE8E;;AAE9E;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;;EAEhB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gEAAgE;EAChE,mEAAmE;EACnE,wCAAwC;EACxC,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;;EAGE;AACF,sBAAsB;AACtB;EACE,qBAAqB;EACrB;;;;IAIE,eAAe;EACjB;;EAEA;;;;IAIE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB;;IAEE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,2EAA2E;AAC3E;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;CACC;AACD;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,wBAAwB;;EAExB,0DAA0D;EAC1D,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;gFAC8E;EAC9E,kBAAkB;EAClB,8CAA8C;EAC9C,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kDAAkD;EAClD,kCAAkC;EAClC,gBAAgB;EAChB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n/*-----------------------------------------------------------------------------\n| Variables\n|----------------------------------------------------------------------------*/\n\n:root {\n  --jp-private-filebrowser-button-height: 28px;\n  --jp-private-filebrowser-button-width: 48px;\n}\n\n.jp-FileBrowser .jp-SidePanel-content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.jp-FileBrowser-toolbar.jp-Toolbar {\n  border-bottom: none;\n  height: auto;\n  margin: 8px 12px 0;\n  box-shadow: none;\n  padding: 0;\n}\n\n.jp-FileBrowser-toolbar.jp-Toolbar::part(positioning-region) {\n  row-gap: 12px;\n}\n\n.jp-FileBrowser-filterToolbar {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n}\n\n.jp-FileBrowser-filterToolbar.jp-Toolbar {\n  border-bottom: none;\n  height: auto;\n  margin: 0 12px 6px;\n  box-shadow: none;\n  padding: 0;\n}\n\n.jp-FileBrowser-Panel {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.jp-BreadCrumbs {\n  flex: 0 0 auto;\n  margin: 8px 12px;\n}\n\n.jp-BreadCrumbs-item {\n  margin: 0 2px;\n  padding: 0 2px;\n  border-radius: var(--jp-border-radius);\n  cursor: pointer;\n}\n\n.jp-BreadCrumbs-item:hover {\n  background-color: var(--jp-layout-color2);\n}\n\n.jp-BreadCrumbs-item:first-child {\n  margin-left: 0;\n}\n\n.jp-BreadCrumbs-item.jp-mod-dropTarget {\n  background-color: var(--jp-brand-color2);\n  opacity: 0.7;\n}\n\n/*-----------------------------------------------------------------------------\n| Buttons\n|----------------------------------------------------------------------------*/\n\n.jp-FileBrowser-toolbar > .jp-Toolbar-item,\n.jp-FileBrowser-filterToolbar > .jp-Toolbar-item {\n  flex: 0 0 auto;\n  padding-left: 0;\n  align-items: center;\n  height: unset;\n}\n\n.jp-FileBrowser-toolbar > .jp-Toolbar-item .jp-ToolbarButtonComponent {\n  width: 28px;\n}\n\n/*-----------------------------------------------------------------------------\n| Other styles\n|----------------------------------------------------------------------------*/\n\n.jp-FileDialog.jp-mod-conflict input {\n  color: var(--jp-error-color1);\n}\n\n.jp-FileDialog .jp-new-name-title {\n  margin-top: 12px;\n}\n\n.jp-FileBrowser .lm-AccordionPanel > h3:first-child {\n  display: none;\n}\n\n.jp-FileBrowser-filterToolbar > .jp-FileBrowser-filterBox {\n  width: 100%;\n}\n\n.jp-FileBrowser-filterBox > .jp-FilterBox {\n  width: 100%;\n}\n\n.jp-Open-Dialog > .jp-FileBrowser {\n  min-height: 200px;\n}\n\n.jp-Open-Dialog-label {\n  overflow: visible;\n}\n\n/*-----------------------------------------------------------------------------\n| DirListing\n|----------------------------------------------------------------------------*/\n\n.jp-DirListing {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  outline: 0;\n  overflow: hidden;\n\n  --jp-dirlisting-padding-width: 12px;\n}\n\n.jp-DirListing-header {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  border-top: var(--jp-border-width) solid var(--jp-border-color2);\n  border-bottom: var(--jp-border-width) solid var(--jp-border-color1);\n  box-shadow: var(--jp-toolbar-box-shadow);\n  z-index: 2;\n  user-select: none;\n}\n\n.jp-DirListing-headerItem {\n  padding: 4px 12px 2px;\n  font-weight: 500;\n  overflow: hidden;\n  white-space: nowrap;\n  box-sizing: border-box;\n  display: flex;\n}\n\n.jp-DirListing-headerItemText {\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.jp-DirListing-headerItem:hover {\n  background: var(--jp-layout-color2);\n}\n\n.jp-DirListing-headerItem.jp-id-name:not([style*='width']) {\n  /* default width before user resizes this column */\n  flex: 1 1 126px;\n}\n\n.jp-DirListing-headerItem.jp-id-modified:not([style*='width']) {\n  /* default width before user resizes this column */\n  flex: 1 0 70px;\n}\n\n.jp-DirListing-headerItem.jp-id-filesize:not([style*='width']) {\n  /* default width before user resizes this column */\n  flex: 0 0 75px;\n}\n\n.jp-DirListing-headerItem.jp-id-modified,\n.jp-DirListing-headerItem.jp-id-filesize {\n  text-align: right;\n  /* stylelint-disable */\n  container-type: inline-size;\n  /* stylelint-enable */\n}\n\n/**\n * Use container queries (not yet supported by our version of stylelint)\n * to display either a small or large header for the last-modified column.\n */\n/* stylelint-disable */\n@container (max-width: 300px) {\n  /* stylelint-enable */\n  .jp-DirListing-headerItem.jp-id-modified\n    > .jp-DirListing-headerItemText-small,\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-small {\n    display: inline;\n  }\n\n  .jp-DirListing-headerItem.jp-id-modified\n    > .jp-DirListing-headerItemText-large,\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-large {\n    display: none;\n  }\n}\n\n/* stylelint-disable */\n@container (min-width: 300px) {\n  /* stylelint-enable */\n  .jp-DirListing-headerItem.jp-id-modified\n    > .jp-DirListing-headerItemText-small {\n    display: none;\n  }\n\n  .jp-DirListing-headerItem.jp-id-modified\n    > .jp-DirListing-headerItemText-large {\n    display: inline;\n  }\n}\n\n/* stylelint-disable */\n@container (max-width: 100px) {\n  /* stylelint-enable */\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-small {\n    display: inline;\n  }\n\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-large {\n    display: none;\n  }\n}\n\n/* stylelint-disable */\n@container (min-width: 100px) {\n  /* stylelint-enable */\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-small {\n    display: none;\n  }\n\n  .jp-DirListing-headerItem.jp-id-filesize\n    > .jp-DirListing-headerItemText-large {\n    display: inline;\n  }\n}\n\n.jp-DirListing-headerItem.jp-mod-selected {\n  font-weight: 600;\n}\n\n/* increase specificity to override bundled default */\n.jp-DirListing-content {\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  overflow: auto;\n  background-color: var(--jp-layout-color1);\n  overflow-x: hidden;\n}\n\n.jp-DirListing-content mark {\n  color: var(--jp-ui-font-color0);\n  background-color: transparent;\n  font-weight: bold;\n}\n\n.jp-DirListing-content .jp-DirListing-item.jp-mod-selected mark {\n  color: var(--jp-ui-inverse-font-color0);\n}\n\n/* Style the directory listing content when a user drops a file to upload */\n.jp-DirListing.jp-mod-native-drop .jp-DirListing-content {\n  outline: 5px dashed rgba(128, 128, 128, 0.5);\n  outline-offset: -10px;\n  cursor: copy;\n}\n\n.jp-DirListing-item {\n  align-items: center;\n  padding: 4px var(--jp-dirlisting-padding-width);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: inline-grid;\n  grid-auto-columns: max-content;\n  width: 100%;\n  box-sizing: border-box;\n  grid-auto-flow: column;\n}\n\n.jp-DirListing-checkboxWrapper {\n  /* Increases hit area of checkbox. */\n  padding: 4px;\n}\n\n.jp-DirListing-content .jp-DirListing-checkboxWrapper {\n  position: relative;\n  left: -4px;\n  margin: -4px 0 -4px -8px;\n}\n\n.jp-DirListing-checkboxWrapper.jp-mod-visible {\n  visibility: visible;\n}\n\n/* For devices that support hovering, hide checkboxes until hovered, selected...\n*/\n@media (hover: hover) {\n  .jp-DirListing-checkboxWrapper {\n    visibility: hidden;\n  }\n\n  .jp-DirListing-item:hover .jp-DirListing-checkboxWrapper,\n  .jp-DirListing-item.jp-mod-selected .jp-DirListing-checkboxWrapper {\n    visibility: visible;\n  }\n}\n\n.jp-DirListing-resizeHandle {\n  min-width: var(--jp-border-width);\n  background: var(--jp-border-color2);\n  height: calc(100% - 4px);\n\n  /* border increases the area where handle can be grabbed */\n  border: 2px solid var(--jp-layout-color1);\n}\n\n.jp-DirListing-resizeHandle.jp-mod-active {\n  background: var(--jp-brand-color1);\n  border-color: var(--jp-brand-color1);\n}\n\n.jp-DirListing-resizeHandle.jp-mod-active:hover {\n  border-color: var(--jp-brand-color1);\n}\n\n.jp-DirListing-resizeHandle:hover {\n  cursor: col-resize;\n  border-color: var(--jp-border-color2);\n}\n\n.jp-DirListing-itemName {\n  display: flex;\n}\n\n.jp-DirListing-item[data-is-dot] {\n  opacity: 75%;\n}\n\n.jp-DirListing-item.jp-mod-selected {\n  color: var(--jp-ui-inverse-font-color1);\n  background: var(--jp-brand-color1);\n}\n\n.jp-DirListing-item.jp-mod-dropTarget {\n  background: var(--jp-brand-color3);\n}\n\n.jp-DirListing-item:hover:not(.jp-mod-selected) {\n  background: var(--jp-layout-color2);\n}\n\n.jp-DirListing-itemIcon {\n  flex: 0 0 20px;\n  margin-right: 4px;\n}\n\n.jp-DirListing-itemText,\n.jp-DirListing-itemModified,\n.jp-DirListing-itemFileSize {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.jp-DirListing-itemName:not([style*='width']) > .jp-DirListing-itemText {\n  flex: 1 1 106px;\n}\n\n.jp-DirListing-item:has(.jp-DirListing-itemText:focus-visible) {\n  /* Targeting `.jp-DirListing-itemText` specifically to avoid an extra outline\n  when it gets replaced with `jp-DirListing-editor` when editing the file name */\n  outline-width: 2px;\n  outline-color: var(--jp-inverse-layout-color1);\n  outline-style: solid;\n  outline-offset: -4px;\n}\n\n.jp-DirListing-item.jp-mod-selected:focus-within {\n  outline-color: var(--jp-layout-color1);\n}\n\n.jp-DirListing-item > .jp-DirListing-itemName > .jp-DirListing-itemText:focus {\n  outline: 0;\n}\n\n.jp-DirListing-itemModified {\n  text-align: right;\n}\n\n.jp-DirListing-itemFileSize {\n  text-align: right;\n}\n\n.jp-DirListing-editor {\n  flex: 1 0 64px;\n  outline: none;\n  border: none;\n  color: var(--jp-ui-font-color1);\n  background-color: var(--jp-layout-color1);\n}\n\n.jp-DirListing-item.jp-mod-running .jp-DirListing-itemIcon::before {\n  color: var(--jp-success-color1);\n  content: '\\25CF';\n  font-size: 8px;\n  position: absolute;\n  left: -8px;\n}\n\n.jp-DirListing-item.jp-mod-running.jp-mod-selected\n  .jp-DirListing-itemIcon::before {\n  color: var(--jp-ui-inverse-font-color1);\n}\n\n.jp-DirListing-item.lm-mod-drag-image,\n.jp-DirListing-item.jp-mod-selected.lm-mod-drag-image {\n  font-size: var(--jp-ui-font-size1);\n  padding-left: 4px;\n  margin-left: 4px;\n  width: 160px;\n  background-color: var(--jp-ui-inverse-font-color2);\n  box-shadow: var(--jp-elevation-z2);\n  border-radius: 0;\n  color: var(--jp-ui-font-color1);\n  transform: translateX(-40%) translateY(-58%);\n}\n\n.jp-Document {\n  min-width: 120px;\n  min-height: 120px;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
